module.exports = __webpack_public_path__ + "img/1f9cc.58f0f75.svg";